import { Badge } from "@chakra-ui/react-v3";
import { BaseTableLayout, ColumnDef } from "../../components/base-table-layout";
import { HighlightedText } from "../../components/highlighted-text";
import { CareGapRowData } from "./care-gaps-rows";

export type CareGapsTableProps = {
  rows: CareGapRowData[];
  onRowClick: (row: CareGapRowData) => void;
  filterQuery: string;
  isRowViewed?: (row: CareGapRowData) => boolean;
};

export function CareGapsTable({ rows, onRowClick, filterQuery, isRowViewed }: CareGapsTableProps) {
  if (!rows.length) return null;

  const columns: ColumnDef<CareGapRowData>[] = [
    { key: "formattedMeasureName", header: "Measure Name" },
    {
      key: "status",
      header: "Status",
      render: (row, searchQuery) => (
        <Badge colorPalette={row.statusColor} variant="subtle" size="sm">
          <HighlightedText text={row.formattedStatus} searchQuery={searchQuery} />
        </Badge>
      ),
    },
    { key: "period", header: "Period", isHiddenOnSmallScreen: true },
  ];

  return (
    <BaseTableLayout
      title="Care Gaps"
      rows={rows}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={onRowClick}
      isRowViewed={isRowViewed}
    />
  );
}
